import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-true",
  "use": "icon-true-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-true\">\n<g id=\"icon-true_&#233;&#128;&#137;&#228;&#184;&#173;\">\n<path id=\"icon-true_Vector 24\" d=\"M4.16016 8.60535L7.58416 13.1707L12.7202 2.89868\" stroke=\"#00D6BE\" stroke-width=\"1.712\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol